import React from 'react';
import I10n from '../features/i10n';
import PropTypes from 'prop-types';
import DocumentationDropdown from './documentation/documentation_dropdown';
import DocumentationLink from './documentation/documentation_link';
import { DOCUMENT_TYPES } from '../constants';

class DocumentationSection extends React.Component {
  static propTypes = {
    documentsLoading: PropTypes.bool,
    hideDatasheets: PropTypes.bool,
    datasheetsLoading: PropTypes.bool,
    documentTypes: PropTypes.array,
    datasheetTypes: PropTypes.array,
    downloadDocuments: PropTypes.func,
    logExport: PropTypes.func,
    documentationKeys: PropTypes.array
  }

  renderDocumentType = (documentType, isLoading) => {
    return (
      <DocumentationLink
        key={documentType.get('name')}
        name={I10n.getOrDefault(`save_configuration.documentation.${documentType.get('name')}`, documentType.get('name'))}
        onDownload={(extension) => {
          this.props.logExport(documentType.get('name'), extension);
        }}
        documentUrl={this.props.downloadDocuments(documentType.get('group'), documentType.get('name'))}
        documentGroup={documentType}
        getLabel={(label) => I10n.get(label)}
        loading={isLoading}
      >
      </DocumentationLink>
    );
  }

  availableDocuments = () => {
    const documentsToConsider = [];

    if (this.props.hideDatasheets == null || !this.props.hideDatasheets) {
      if (this.props.datasheetsLoading) {
        const documentType = new Map();
        documentType.set('name', DOCUMENT_TYPES.PRODUCT_DATASHEET);
        documentType.set('group', []);
        documentsToConsider.push({documentType, isLoading: true});
      } else {
        this.props.datasheetTypes.forEach((documentType) => {
          documentsToConsider.push({documentType, isLoading: false});
        });
      }
    }

    if (this.props.documentsLoading) {
      this.props.documentationKeys.filter(key => key !== DOCUMENT_TYPES.PRODUCT_DATASHEET).forEach(docKey => {
        const documentType = new Map();
        documentType.set('name', docKey);
        documentType.set('group', []);
        documentsToConsider.push({documentType, isLoading: true});
      });
    } else {
      this.props.documentTypes.forEach((documentType) => {
        documentsToConsider.push({documentType, isLoading: false});
      });
    }

    return documentsToConsider.filter(obj =>  this.props.documentationKeys.some((arrVal) => obj.documentType.get('name') === arrVal));
  }

  renderDocuments = (documentsToConsider) => {
    const components = [];
    for (const documentTypeObj of documentsToConsider) {
      components.push(this.renderDocumentType(documentTypeObj.documentType, documentTypeObj.isLoading));
    }

    return components;
  }

  renderTitle = (availableDocuments) => {
    let result = I10n.get('save_configuration.documentation.title');

    if (!this.props.documentsLoading && !this.props.datasheetsLoading) {
      let nbAvailableDocumentTypes = 0;

      availableDocuments.forEach((documentTypeObj) => {
        if (documentTypeObj.documentType.get('group').length > 0) {
          nbAvailableDocumentTypes += 1;
        }
      });

      if (nbAvailableDocumentTypes > 0) {
        result += ` (${nbAvailableDocumentTypes})`;
      }
    }

    return result;
  }

  render = () => {
    const availableDocuments = this.availableDocuments();
    const documentComponents = this.renderDocuments(this.availableDocuments());
    return (
      <>
        {documentComponents.length > 0 && <DocumentationDropdown
          defaultOpenStatus={window.innerWidth > 800}
          title={this.renderTitle(availableDocuments)}
          children={documentComponents}>
        </DocumentationDropdown>}
      </>
    );
  }
}

export default DocumentationSection;
